import React from 'react';
import UsersContext from './UsersContext';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import UserPermissions from './UserPermissions';
import CircularProgress from '@material-ui/core/CircularProgress';

const Container = styled.div`
    display:flex;
    width:100%;
    padding:10px;
    padding-left:20px;
    height:56px;
    justify-content:space-between;
    align-items:center;
`;

const Divider = styled.div`
    width:100%;
    height:1px;
    background-color:rgba(0, 0, 0, 0.20000000298023224);
`;

const Divider2 = styled.div`
    width:100%;
    height:1px;
    background-color:rgba(0, 0, 0, 0.20000000298023224);
`;


const SelectedUser = styled.div`
color: rgba(0, 0, 0, 0.87);
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
`;

const SubHeader = styled.div`
padding-top:10px;
display:grid;
grid-template-columns:154px 154px 269px 159px 174px;
padding-left:10px;
padding-right:10px;
padding-bottom:10px;

`;

const SubHeaderText = styled.div`
color: gray;
font-family: Roboto;
font-size: 14px;
font-weight: 500;
line-height: 19px;
text-align: left;
`;

const CancelSaveContainer = styled.div`

`;


const CircularProgressContainer = styled.div`
    padding-right:20px;

`;

const SelectedUserContainer = styled.div`
    display:flex;
    align-items:center;
`;

const DeleteButtonContainer = styled.div`
    padding-right:10px;
`;

const UserBun = styled.span`
    font-size: 12px;
`

const UsersDetailsHeader = ({ formProps }) => {

    return (<UsersContext.Consumer>
        {context =>
            <>
                <Container>
                    {context.users.selectedUser &&
                        <>
                            <SelectedUserContainer>
                                {context.editingUserDetails &&
                                    <DeleteButtonContainer>
                                        <Button onClick={() => { context.showDeleteUserDialog() }}>
                                            Delete
                                        </Button>
                                    </DeleteButtonContainer>
                                }
                                <SelectedUser>{context.users.selectedUser.displayName} <UserBun>( {context.users.selectedUser.bun} )</UserBun></SelectedUser>

                            </SelectedUserContainer>
                            {!context.editingUserDetails &&
                                <Button onClick={() => context.editUserDetails()}>
                                    Edit
                                </Button>
                            }
                            {context.editingUserDetails && !context.users.savingUserDetails &&

                                <CancelSaveContainer >
                                    <Button
                                        onClick={() => {
                                            context.cancelEditingUserDetails();
                                            formProps.resetForm();
                                        }}>
                                        Cancel
                                    </Button>
                                    <Button onClick={() => formProps.submitForm()}>
                                        Save
                                    </Button>
                                </CancelSaveContainer>
                            }
                            {context.editingUserDetails && context.users.savingUserDetails &&

                                <CircularProgressContainer >
                                    <CircularProgress size={25} />
                                </CircularProgressContainer>
                            }

                        </>
                    }
                </Container>
                <UserPermissions formProps={formProps} />
                <Divider />
                <SubHeader>
                    <SubHeaderText>Role</SubHeaderText>
                    <SubHeaderText>Scope</SubHeaderText>
                    <SubHeaderText>Project</SubHeaderText>
                    <SubHeaderText>GBU</SubHeaderText>
                    <SubHeaderText>Function</SubHeaderText>
                </SubHeader>
                <Divider2 />

            </>
        }
    </UsersContext.Consumer>)
}

export default UsersDetailsHeader;